import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Banner from "../../components/common/Banner";
import Footer from "../../components/common/utils/Footer.js";
import * as actions from "../../redux/actions/leaveActions";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

class LeaveHome extends React.Component {

  constructor() {
    super();
    this.state = ({name: 'Leave',isVertical: false});
    this.changeBanner = this.changeBanner.bind(this);
  }

  componentDidMount() {

    this.props.dispatch(actions.getOptionalLeaves());
    this.props.dispatch(actions.getLeaveHistory());
    this.setState({isVertical:this.props.emp.vertical});
  }

  changeBanner(name) {
    this.setState({name: name});
  }

  render() {
    return (
      <div>
        <Banner name={this.state.name}/>
        <div className="container">
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content">
                  <ul className="nav nav-tabs tabs responsive" role="tablist">
                    <li
                      className={window.location.hash.split('?')[0].split('/')[3] == undefined || window.location.hash.split('?')[0].split('/')[3] == "apply" ? "active" : null }
                      rel="apply"><a href="#/1/leave/apply" rel="apply" role="tab" data-toggle="tab">Apply leave</a>
                    </li>
                    <li className={window.location.hash.split('?')[0].split('/')[3] == "history" ? "active" : null }
                        rel="history"><a href="#/1/leave/history" rel="history" role="tab" data-toggle="tab">My Leave
                      History</a></li>

                    {this.props.manager ?
                      <li className={window.location.hash.split('?')[0].split('/')[3] == "team" ? "active" : null }
                          rel="team"><a href="#/1/leave/team" rel="team" role="tab" data-toggle="tab">Team Leave</a>
                      </li> : null}
                    {this.props.manager ?
                      <li
                        className={window.location.hash.split('?')[0].split('/')[3] == "teamhistory" ? "active" : null }
                        rel="team"><a href="#/1/leave/teamhistory" rel="team" role="tab" data-toggle="tab">Team Leave
                        History</a></li> : null}


                  </ul>
                  <div className="tab-content responsive">
                    <ReactCSSTransitionGroup transitionName="example"
                                             transitionAppear={true} transitionAppearTimeout={500}
                                             transitionEnter={false} transitionLeave={false}>

                      {React.cloneElement(this.props.children, {
                        changeBanner: this.changeBanner,
                        isVertical: this.state.isVertical
                      })}
                    </ReactCSSTransitionGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>



    );
  }

}

LeaveHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state,
    manager: state.emp[0].manager
  };

}
export default connect(mapStateToProps)(LeaveHome);




/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveHome.js
 **/